/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ProjectDescription
 */
export interface ProjectDescription {
    /**
     * 
     * @type {string}
     * @memberof ProjectDescription
     */
    value: string;
}

/**
 * Check if a given object implements the ProjectDescription interface.
 */
export function instanceOfProjectDescription(value: object): value is ProjectDescription {
    if (!('value' in value) || value['value'] === undefined) return false;
    return true;
}

export function ProjectDescriptionFromJSON(json: any): ProjectDescription {
    return ProjectDescriptionFromJSONTyped(json, false);
}

export function ProjectDescriptionFromJSONTyped(json: any, ignoreDiscriminator: boolean): ProjectDescription {
    if (json == null) {
        return json;
    }
    return {
        
        'value': json['value'],
    };
}

export function ProjectDescriptionToJSON(value?: ProjectDescription | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'value': value['value'],
    };
}

